import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const CourseDisclosureContainer = styled('section')`
  ${flexCenter}

  flex-direction: column;
  height: auto;
  padding: 0 16px;
  padding-inline: 16px;
  text-align: left;

  ${mediaQuery('', 'mobile')} {
    padding: 0;
    padding-inline: 0;
  }

  ${mediaQuery('tablet', 'mobile')} {
    max-width: 548px;
  }

  ${mediaQuery('', 'tablet')} {
    max-width: 576px;
  }
`

const CourseDisclosureTitle = styled('h2')`
  margin: 24px 0;
  margin-block: 24px;
  text-align: left;
  width: inherit;

  ${mediaQuery('', 'laptop')} {
    margin-top: 48px;
    margin-block-start: 48px;
  }
`

const CourseDisclosureContent = styled('div')`
  margin-bottom: 24px;
  width: inherit;
  & > ul {
    padding: 0 16px;
    word-break: break-word;
    overflow-wrap: break-word;
  }
`

export {
  CourseDisclosureContainer,
  CourseDisclosureContent,
  CourseDisclosureTitle
}
